module.exports = __webpack_public_path__ + "media/post-listing-block-3-overlay@2x.dcc83ea4.png";